<template>
  <v-container fluid>
    <v-row>
      <v-spacer />
      <v-col cols="12" md="11" class="pa-0">
        <v-card>
          <v-card-title class="pb-0">
            <v-icon class="mr-1">mdi-ticket-plus-outline</v-icon>
            Ticket anlegen
          </v-card-title>
          <v-card-text>
            <v-row dense class="mt-2">
              <v-col cols="12" md="8">
                <h5 class="text-caption grey--text">Titel:</h5>
                <v-text-field
                  id="new_ticket_title"
                  v-model="new_ticket.title"
                  placeholder="Titel des Tickets"
                  hide-details
                  dense
                  outlined
                  @keydown.enter="createTicket"
                />
              </v-col>
              <v-col cols="12" md="4">
                <h5 class="text-caption grey--text">Workflow-Vorlage:</h5>
                <v-autocomplete
                  v-model="new_ticket.workflow_blueprint_id"
                  :items="workflows"
                  item-text="name"
                  item-value="id"
                  placeholder="Ohne Workflow"
                  hide-details
                  dense
                  outlined
                  clearable
                />
              </v-col>
              <v-col cols="12">
                <h5 class="text-caption grey--text">Configuration Items:</h5>
                <v-autocomplete
                  v-model="new_ticket.cis"
                  :items="$store.state.ticketsystem.cis"
                  item-text="name"
                  item-value="id"
                  placeholder="(optional) verknüpfte CIs"
                  hide-details
                  dense
                  outlined
                  multiple
                  single-line
                  chips
                  small-chips
                  deletable-chips
                />
              </v-col>
              <v-col cols="12">
                <h5 class="text-caption grey--text">Beschreibung:</h5>
                <v-textarea
                  v-model="new_ticket.text"
                  placeholder="(optional) Kontext zum Ticket"
                  outlined
                  dense
                  hide-details
                  rows="3"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              class="primary"
              :disabled="!canCreate"
              :loading="creating"
              @click="createTicket"
            >
              Erstellen
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-spacer />
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "CreateTicket",
  data: () => ({
    creating: false,
    new_ticket: {
      title: "",
      text: "",
      cis: [],
      workflow_blueprint_id: null,
      data: {},
    },
  }),
  computed: {
    workflows() {
      return [...this.$store.state.ticketsystem.workflows]
        .sort((a, b) => (a.name || "").localeCompare(b.name || ""))
    },
    canCreate() {
      return (this.new_ticket.title || "").trim().length > 0
    },
  },
  methods: {
    async createTicket() {
      if (!this.canCreate || this.creating) return
      this.creating = true
      try {
        const payload = {
          title: this.new_ticket.title.trim(),
          text: this.new_ticket.text || "",
          cis: this.new_ticket.cis,
          data: this.new_ticket.data,
          creator_id: this.$store.state.user.id,
        }
        if (this.new_ticket.workflow_blueprint_id != null) {
          payload.workflow_blueprint_id = this.new_ticket.workflow_blueprint_id
        }
        await this.$store.dispatch("update", {
          payload_type: "POST",
          context: "/tickets",
          payload,
        })
        this.new_ticket.title = ""
        this.new_ticket.text = ""
        this.new_ticket.cis = []
        this.new_ticket.workflow_blueprint_id = null
      } finally {
        this.creating = false
      }
    },
  },
  mounted() {
    if (this.$store.state.ticketsystem.workflows.length === 0) {
      this.$store.dispatch("update", { context: "/workflows" })
    }
    if (document.getElementById("new_ticket_title")) {
      document.getElementById("new_ticket_title").focus()
    }
  },
}
</script>
